<div class="banner-stage flex justify-content-center w-full">
  <p-carousel
    [value]="slideList()"
    [numVisible]="1"
    [numScroll]="1"
    [circular]="true"
    [autoplayInterval]="7000"
    styleClass="home-banner-carousel"
  >
    <ng-template let-slide pTemplate="item">
      <div class="banner-slide relative overflow-hidden">
        <img
          class="banner-photo absolute top-0 left-0 w-full h-full"
          [src]="slide.image"
          [alt]="slide.imageAlt"
          [style.object-position]="slide.imagePosition ?? 'center'"
          loading="lazy"
        />
        <div class="banner-scrim absolute top-0 left-0 w-full h-full" aria-hidden="true"></div>

        <div
          class="banner-content relative z-1 flex flex-column align-items-start justify-content-center h-full gap-2 md:gap-3"
        >
          @if (slide.kicker) {
            <div class="banner-kicker flex align-items-center gap-2">
              <span class="banner-kicker-bar border-round" [style.background]="slide.accent"></span>
              @if (slide.kickerIcon) {
                <i class="pi {{ slide.kickerIcon }}"></i>
              }
              <span>{{ slide.kicker }}</span>
            </div>
          }

          <h2 class="banner-title m-0">{{ slide.title }}</h2>
          <p class="banner-subtitle m-0">{{ slide.subtitle }}</p>

          <div class="banner-cta-row mt-2">
            <p-button
              [label]="slide.ctaLabel"
              icon="pi pi-arrow-right"
              iconPos="right"
              [rounded]="true"
              styleClass="banner-cta"
              (onClick)="ctaClick.emit(slide)"
            />
          </div>
        </div>
      </div>
    </ng-template>
  </p-carousel>
</div>
